export default __webpack_public_path__ + "static/media/milestone 1900.374b5e1d.svg";